import { render, staticRenderFns } from "./DropdownOptionsSupplierOrder.vue?vue&type=template&id=64e5c08c&scoped=true&"
import script from "./DropdownOptionsSupplierOrder.vue?vue&type=script&lang=js&"
export * from "./DropdownOptionsSupplierOrder.vue?vue&type=script&lang=js&"
import style0 from "./DropdownOptionsSupplierOrder.vue?vue&type=style&index=0&id=64e5c08c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5c08c",
  null
  
)

export default component.exports